<div>
    <span class="occurs">{{ "label.editPool.resOrUnres" | translate | async }}</span>
    <div class="day-holder">
        <span *ngFor="let day of daysOfWeek; let i=index">
            <vue-slide-toggle 
            class="occur"
            [disabled]="!restrictedDays.includes(i)"
            [checked]="restrictedDays.includes(i) && day.checked" (change)="checkboxChange(day.value,$event)"
            matTooltip="{{ getToolTip(day.checked) | async }}"
            >            
            </vue-slide-toggle>
        </span>
        
    </div>
</div>
  <!-- {{this.daysOfWeek |json}} -->
<div>

     <span class="occurs">{{ "label.editPool.allowQueue" | translate | async }}</span>
          <vue-image-tooltip  imageSrc="/assets/icons/icon-exclamation.svg"
        content="{{ 'tooltip.message.openunestrictedpool' | translate | async }}"></vue-image-tooltip>
     <div class="day-holder2">

        <span *ngFor="let day of daysOfWeek; let i=index">
            <mat-checkbox style="font-weight: bold;margin-top: 2%;"  [disabled]="day?.checked || !restrictedDays.includes(i) " [checked]=" day?.isQueueAllowed"   (change)="checkboxData(day.value,$event,daysOfWeek)">
           </mat-checkbox>
        </span>
        
     </div>
</div>